const MobilePhonePrefixes = [
    {id: 105, name: "+353"},
    {id: 229, name: "+44"}
]

export default MobilePhonePrefixes;